import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from './../redux/hooks';
import Box from '@mui/material/Box';

import Page from '../components/general/containers/Page';
import NavBar from '../components/general/navBar/NavBar';
import DoctorSettings from '../components/doctor/navigation/navBar/Settings';
import Sidebar from '../components/general/navigation/Sidebar';
import ImageViewer from '../components/doctor/dashboard/viewers/image/ImageViewer';
import FileViewer from '../components/doctor/dashboard/viewers/file/FileViewer';
import NoteViewer from '../components/doctor/dashboard/viewers/note/NoteViewer';
import LanguagePopup from '../components/general/popups/LanguagePopup';
import Agreement from '../components/doctor/dashboard/popups/Agreement';
import SuspendedGroupPopup from '../components/general/popups/SuspendedGroupPopup';
import LockScreenWarning from '../components/lockScreen/warning/LockScreenWarning';

import { setSideBarMenu, setDashboardSection } from '../redux/features/general/navigation';
import menuItems from '../util/navigation/sidebarMenu/doctor';

// Import the dashboard components that will be rendered by the router
import Consultation from '../components/doctor/dashboard/consultation/Consultation';
import Templates from '../components/doctor/dashboard/templates/Templates';
import FileExplorer from '../components/doctor/dashboard/fileExplorer/FileExplorer';
import PatientsInterface from '../components/doctor/dashboard/PatientsInterface';
import InsurersInterface from '../components/doctor/dashboard/InsurersInterface';


const Dashboard: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { section: currentSectionFromUrl } = useParams<{ section?: string }>();

  const sectionFromRedux = useAppSelector((state) => state.navigation.section);
  const isImageViewerOpened = useAppSelector(state => state.imageViewer.isImageViewerOpened);
  const isFileViewerOpened = useAppSelector(state => state.fileViewer.isFileViewerOpened);
  const isNoteViewerOpened = useAppSelector(state => state.noteViewer.isNoteViewerOpened);
  const isLanguagePopupOpened = useAppSelector(state => state.navigation.isLanguagePopupOpened);
  const isAgreementPopupOpened = useAppSelector(state => state.navigation.isAgreementPopupOpened);
  const isSuspendedGroupPopupOpened = useAppSelector(state => state.navigation.isSuspendedGroupPopupOpened);
  const isLockScreenWarningPopupOpened = useAppSelector(state => state.navigation.isLockScreenWarningPopupOpened);

  useEffect(() => {
    dispatch(setSideBarMenu(menuItems));
  }, [dispatch]);

  useEffect(() => {
    if (currentSectionFromUrl) {
      dispatch(setDashboardSection(currentSectionFromUrl));
    } else if (menuItems.length > 0) {
      navigate(`/dashboard/${menuItems[0].section}`, { replace: true });
    }
  }, [currentSectionFromUrl, dispatch, navigate]);

  const renderSection = () => {
    switch (sectionFromRedux) {
      case 'consultation':
        return <Consultation />;
      case 'templates':
        return <Templates />;
      case 'documents':
        return <FileExplorer />;
      case 'patients':
        return <PatientsInterface />;
      case 'insurers':
        return <InsurersInterface />;
      default:
        // Render a loading state or the default component while redirecting
        return null;
    }
  };

  return (
    <Page>
      <NavBar>
        <DoctorSettings />
      </NavBar>

      <Sidebar />

      {renderSection()}

      {isImageViewerOpened && <ImageViewer />}
      {isFileViewerOpened && <FileViewer />}
      {isNoteViewerOpened && <NoteViewer />}
      {isLanguagePopupOpened && <LanguagePopup />}
      {isAgreementPopupOpened && <Agreement />}
      {isSuspendedGroupPopupOpened && <SuspendedGroupPopup />}
      {isLockScreenWarningPopupOpened && <LockScreenWarning />}
    </Page>
  );
};

export default Dashboard;